export const VARIANT_SHOWN = 'shown';
export const VARIANT_HIDDEN = 'hidden';

export const UPDATE_PRIVACY_POLICY_BANNER_FLAG = {
    experimentId: 'UpdatePrivacyPolicyBanner',
    defaultAssignment: VARIANT_HIDDEN,
    isFeatureFlag: true,
};
